
import { axios } from "../../helper/axios";
import { SearchHistoryConstant } from "./SearchHistoryConstant";


const SearchHistoryApiData = {};

SearchHistoryApiData.getSearchHistoryData = ({
  from_date,
  to_date,
  search_term,
  page = 1,
  limit,
  sorting
}) => {
  let qeuryParam = [];

  if (page !== undefined && page !== null) {
    qeuryParam.push(`page=${page}`);
  }
  if (limit !== undefined && limit !== null) {
    qeuryParam.push(`pageSize=${limit}`);
  }
  if (search_term !== undefined && search_term !== null) {
    qeuryParam.push(`search=${search_term}`);
  }
  if (from_date && to_date) {
    qeuryParam.push(`startDate=${from_date}&endDate=${to_date}`);
  }
  if (sorting) {
    qeuryParam.push(`checkIn=${sorting}`);
  }


  // Join all parameters with '&'
  const queryString = qeuryParam.length ? `?${qeuryParam.join('&')}` : '';

  return axios.get(`${SearchHistoryConstant.SEARCHHISTORY_API}${queryString}`);
};

SearchHistoryApiData.exportBulkApiData = ({
  limit
}) => {


  let qeuryParam ='';
 
 if( limit){
   qeuryParam = `?pageSize=${limit}`;

 }

    return axios.get(`${SearchHistoryConstant.SEARCHHISTORY_API}${qeuryParam}`);
}
export { SearchHistoryApiData };
